module.exports = __webpack_public_path__ + "static/img/my_on.01a64b53.png";